/**
 * Determine if a given hex color is "light" (close to white).
 */
export function isLightColor(hexColor: string): boolean {
  if (!hexColor) return false

  // Remove any leading '#' if present
  const color = hexColor.replace('#', '')

  // Parse R, G, B from hex
  let r, g, b
  if (color.length === 3) {
    // Three-character hex e.g. #FFF
    r = parseInt(color[0] + color[0], 16)
    g = parseInt(color[1] + color[1], 16)
    b = parseInt(color[2] + color[2], 16)
  } else {
    // Six-character hex e.g. #FFFFFF
    r = parseInt(color.substring(0, 2), 16)
    g = parseInt(color.substring(2, 4), 16)
    b = parseInt(color.substring(4, 6), 16)
  }

  // Calculate "brightness" using the luma formula
  // Common thresholds for "light" can vary; 220 is a decent starting point
  const brightness = 0.299 * r + 0.587 * g + 0.114 * b
  return brightness >= 220
}

function getColorOrder(color: string): number {
  const lower = color.toLowerCase()

  // Check for variants representing black
  if (lower.includes('black') || lower.includes('blk') || lower.endsWith('bk')) {
    return 0
  }
  // Check for white
  if (lower.includes('white')) {
    return 1
  }
  // Check for gray/grey
  if (lower.includes('gray') || lower.includes('grey')) {
    return 2
  }
  // Everything else falls into group 3
  return 3
}

export function compareColors(colorA: string, colorB: string): number {
  const orderA = getColorOrder(colorA)
  const orderB = getColorOrder(colorB)
  if (orderA !== orderB) {
    return orderA - orderB
  }
  // If both are in the same group, sort alphabetically
  return colorA.localeCompare(colorB)
}
